import {createWebHistory, createRouter} from 'vue-router'

import LoginView from './views/Login.vue'
import RegisterView from './views/Register.vue'
import HomeView from './views/Home.vue'
import ProductsView from './views/Products.vue'
import StoresView from './views/Stores.vue'
import StrategiesView from './views/Strategies.vue'
import StrategyView from './views/Strategy.vue'
import PricesView from './views/Prices.vue'
import SettingsView from './views/Settings.vue'
import PaymentView from './views/Payment.vue'
import TariffsView from './views/Tariffs.vue'
import OzonOauthView from './views/OzonOauth.vue'
import ReportV1View from './views/ReportV1.vue'
import {menu} from '@/data/menu'
import {auth} from '@/data/auth'
import {PageInfo} from "@/data/page";
import {billingEnabled, billingRoutes} from "@/modules/billing";

const routes = [
    {
        path: '/',
        name: 'home',
        meta: {
            title: 'Главная',
        },
        component: HomeView
    },
    {
        path: '/login',
        name: 'login',
        meta: {
            title: 'Вход',
        },
        component: LoginView
    },
    {
        path: '/register',
        name: 'register',
        meta: {
            title: 'Регистрация',
        },
        component: RegisterView
    },
    {
        path: '/stores',
        name: 'stores',
        meta: {
            title: 'Магазины',
        },
        component: StoresView
    },
    {
        path: '/products',
        name: 'products',
        meta: {
            title: 'Товары',
        },
        component: ProductsView
    },
    {
        path: '/prices',
        name: 'prices',
        meta: {
            title: 'Ценообразование',
        },
        component: PricesView
    },
    {
        path: '/strategies',
        name: 'strategies',
        meta: {
            title: 'Стратегии ценообразования',
        },
        component: StrategiesView
    },
    {
        path: '/strategies/add',
        name: 'strategy-add',
        meta: {
            title: 'Новая стратегия',
            active: 'strategies',
        },
        component: StrategyView,
        props: {isNew: true}
    },
    {
        path: '/strategies/:id',
        name: 'strategy-edit',
        meta: {
            title: 'Редактировать стратегию',
            active: 'strategies',
        },
        component: StrategyView,
        props: (route) => ({id: route.params.id, isNew: false})
    },
    {
        path: '/report_v1',
        name: 'report_v1',
        meta: {
            title: 'Отчет по заказам',
        },
        component: ReportV1View
    },
    {
        path: '/settings',
        name: 'settings',
        meta: {
            title: 'Настройки',
        },
        component: SettingsView
    },
    {
        path: '/payment',
        name: 'payment',
        meta: {
            title: 'Оплата тарифа',
            active: 'settings',
        },
        component: PaymentView
    },
    {
        path: '/tariffs',
        name: 'tariffs',
        meta: {
            title: 'Тарифы',
        },
        component: TariffsView
    },
    {
        path: '/oauth/ozon',
        name: 'oauth-ozon',
        meta: {
            title: 'Интеграция с Озон',
        },
        component: OzonOauthView
    },
    ...(billingEnabled ? billingRoutes : []),
]

const router = createRouter({
    history: createWebHistory(),
    routes,
})

router.afterEach((to) => {
    menu.update(to)
})

router.beforeEach(async (to) => {
    PageInfo.clear()
    document.title = to.meta.title
    if (to.name === 'login' || to.name === 'register'|| to.name === 'oauth-ozon') {
        return
    }
    if (!auth.checkAuth()) {
        await router.push({name: 'login'})
    }
})

export default router